import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ItemSentInfo from '../ItemSentInfo';
import ItemStatusChips from '../ItemStatusChips';
import StatusChip from '../StatusChip';
import { typeInfo } from '../../../../../components/changelog/changelogConfig';

const OTHER_EDITION_WARNING = { color: '#B45309', bg: '#FFF4E5' };

// Motivo para o item não poder entrar no envio (null = pode)
export const pickBlockReason = (item, alreadyIn) => {
  if (alreadyIn) return 'Já está neste envio';
  if (item.awaiting_deploy) return 'Aguardando deploy: ainda não está no ar';
  if (item.status === 'internal') return 'Novidade interna não sai em envio';
  if (item.status === 'draft') return 'Ainda em rascunho: marque como revisado no Catálogo';
  return null;
};

/**
 * Uma novidade no seletor "Adicionar itens". Já ter saído em outro envio é só um aviso.
 * @param {{ item: Object, editionId: number, alreadyIn: boolean, checked: boolean, onToggle: Function }} props
 */
function ItemPickerRow({ item, editionId, alreadyIn, checked, onToggle }) {
  const reason = pickBlockReason(item, alreadyIn);
  const type = typeInfo(item.type);
  const otherSent = (Array.isArray(item.editions) ? item.editions : [])
    .filter((edition) => edition.id !== editionId && ['sent', 'sending', 'scheduled'].includes(edition.status));

  const box = (
    <Checkbox size="small" checked={alreadyIn || checked} disabled={Boolean(reason)} onChange={() => onToggle(item)} />
  );

  return (
    <Box
      component="li"
      sx={{
        display: 'flex', alignItems: 'flex-start', gap: 1, px: 2, py: 1.25,
        borderBottom: '1px solid #EEF1F6', opacity: reason && !alreadyIn ? 0.6 : 1,
        cursor: reason ? 'default' : 'pointer',
      }}
      onClick={(e) => { if (!reason && e.target.type !== 'checkbox') onToggle(item); }}
    >
      {reason ? <Tooltip title={reason}><span>{box}</span></Tooltip> : box}
      <Box sx={{ minWidth: 0, flex: 1, pt: 0.75 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.25 }}>
          <Typography variant="caption" sx={{ color: type.color, fontWeight: 700 }}>{type.label}</Typography>
          <ItemStatusChips item={item} />
          {otherSent.map((edition) => (
            <StatusChip
              key={edition.id}
              info={{ ...OTHER_EDITION_WARNING, label: edition.status === 'scheduled' ? `Agendado no envio #${edition.number}` : `Já saiu no envio #${edition.number}` }}
            />
          ))}
        </Box>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.title || 'Sem título'}</Typography>
        {item.summary && (
          <Typography variant="caption" color="text.secondary" sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {item.summary}
          </Typography>
        )}
      </Box>
      <Box sx={{ minWidth: 150, maxWidth: 200, pt: 0.75, display: { xs: 'none', sm: 'block' } }}>
        <ItemSentInfo item={item} excludeEditionId={editionId} />
      </Box>
    </Box>
  );
}

export default ItemPickerRow;
